import { Link } from "react-router-dom";
import { FormattedMessage  } from 'react-intl';
import { getCurrencySymbol, drawSupply, compareStrings } from '../utils/utils';

export function GetMostActiveColumns(link_name, parent_id_param, days_number)
{
    const formatConfig = {
        style: 'currency',
        currency: getCurrencySymbol(navigator.language || navigator.userLanguage),
        minimumFractionDigits: 2,
        currencyDisplay: 'symbol',
    };

    const currencyFormatter = new Intl.NumberFormat(navigator.language || navigator.userLanguage, formatConfig);

    return [
        {
          title: <FormattedMessage id="DeviceMetersTable.name"/>,
          dataIndex: 'name',
          
          width: '300px',
          sorter: {
            compare: (a, b) => compareStrings(a.name, b.name)
          },
          render: (_, record) => {
            const url = link_name + "/" + record.id + (parent_id_param !== undefined ? parent_id_param : "");
            return(
            <div>
                <Link to={url}>{record.name}</Link>
            </div>
            );
          }   
        },
        {
            title: <FormattedMessage id="Workload"/>,
            dataIndex: 'id',
            
            render: (_, record) => {
                return(drawSupply({level: record.workload, maxCapacity: 100, color: "lawngreen"}));
              }   
        },
        {
            title: <FormattedMessage id="Documents"/>,
            dataIndex: 'documents',
            
            sorter: {
              compare: (a, b) => a.documents - b.documents,
            },
        },
        {
            title: <FormattedMessage id="Pages"/>,
            dataIndex: 'pages',
            
            sorter: {
              compare: (a, b) => a.pages - b.pages,
            },
        },
        {
            title: <FormattedMessage id="Cost"/>,
            dataIndex: 'cost',
            
            sorter: {
              compare: (a, b) => a.cost - b.cost,
            },
            render: (_, record) =>
                <div>
                    {currencyFormatter.format(record.cost === undefined ? 0 : record.cost)}
                </div>
        },
        {
            title: <FormattedMessage id="DocsPerDay"/>,
            dataIndex: 'id',
            
            render: (_, record) => {
                return(
                <div>
                    {days_number > 0 ? Math.round(record.documents / days_number) : ''}
                </div>
                );
              }   
        },
        {
            title: <FormattedMessage id="PagesPerDay"/>,
            dataIndex: 'id',
            
            render: (_, record) => {
                return(
                <div>
                    {days_number > 0 ? Math.round(record.pages / days_number) : ''}
                </div>
                );
              }   
        },
    ];
}
